import React from 'react';
import Svg, {Path} from 'react-native-svg';

interface LightModeIconProps {
  color?: string;
  size?: number;
}

const LightModeIcon = ({color = '#000000', size = 24}: LightModeIconProps) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    {/* Crescent moon */}
    <Path
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default LightModeIcon;